import type { SVGProps } from 'react';
const SvgDataTransfer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    height={16}
    fill="none"
    width={16}
    {...props}
  >
    <path
      d="M2.9 3.634a1 1 0 0 0-.2.056c-.093.04-.174.117-1.09 1.03A41 41 0 0 0 .572 5.773c-.086.123-.115.23-.115.418 0 .199.031.297.141.444.038.05.497.517 1.02 1.037.698.694.971.956 1.03.987.228.12.51.121.73.001a.9.9 0 0 0 .322-.35c.05-.104.051-.116.051-.31v-.2l-.061-.126c-.055-.11-.098-.161-.359-.427l-.296-.302h2.96c2.041 0 2.987-.005 3.052-.017a.77.77 0 0 0 .602-.631.78.78 0 0 0-.164-.59.84.84 0 0 0-.345-.234c-.103-.031-.144-.032-3.113-.032h-3.01l.313-.316c.267-.27.32-.332.367-.428.053-.11.054-.116.054-.32 0-.203-.001-.211-.051-.314a.75.75 0 0 0-.8-.428Zm9.885 3.64a.77.77 0 0 0-.479.405c-.058.119-.059.121-.059.321v.202l.062.125c.055.11.098.162.359.427l.296.302h-2.96c-2.041 0-2.988.006-3.052.017a.77.77 0 0 0-.602.632.76.76 0 0 0 .517.826c.091.028.222.03 3.105.03h3.01l-.313.315c-.267.27-.32.333-.367.428-.053.11-.055.116-.055.32s.001.21.055.32a.76.76 0 0 0 .793.422c.24-.029.209-.002 1.33-1.124.874-.874 1.015-1.022 1.05-1.1a.76.76 0 0 0-.075-.777 33 33 0 0 0-1.019-1.037c-.698-.695-.971-.956-1.03-.988a.8.8 0 0 0-.566-.066"
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDataTransfer;
